import React from 'react';
import { MessageCircle } from 'lucide-react';

const Community = () => {
  return (
    <section id="comunidade" className="relative py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <div className="gradient-border p-8 md:p-14 text-center relative overflow-hidden">
          <div className="hidden md:block absolute -top-20 -right-20 w-72 h-72 rounded-full bg-cyan-500/15 blur-3xl pointer-events-none" />
          <div className="hidden md:block absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-teal-500/15 blur-3xl pointer-events-none" />

          <div className="relative">
            <h2 className="text-3xl md:text-5xl font-extrabold leading-tight mb-4">
              <span className="text-white">Você não está</span> <span className="gradient-text">sozinho</span>
            </h2>
            <p className="text-white/65 text-base md:text-lg max-w-xl mx-auto mb-8">
              Junte-se à comunidade de brasileiros que estão quebrando o ciclo das apostas online.
              Compartilhe sua jornada, receba apoio e fortaleça-se.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a
                href="https://discord.com/channels/1493208568881614938/1493208569368281150"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-6 h-12 rounded-full bg-gradient-to-r from-indigo-500/20 to-purple-500/20 border border-indigo-400/30 hover:border-indigo-400/60 transition-colors text-white text-sm font-semibold"
              >
                <MessageCircle className="w-4 h-4" />
                Entrar no Discord
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
